import { motion } from 'framer-motion';
import { properties } from '../../data/properties';
import PropertyCard from '../properties/PropertyCard';
import 'swiper/css';
import 'swiper/css/pagination';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';

interface PropertyListProps {
  search: string;
}

export default function PropertyList({ search }: PropertyListProps) {
  const filteredProperties = properties.filter(property => 
    property.title.toLowerCase().includes(search.toLowerCase()) ||
    property.location.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="mb-16">
      <h2 className="text-primary text-center mb-4">Featured Properties</h2>
      <p className="text-body-large text-gray-600 text-center mb-12">
        Explore some of our handpicked selection of high-performing properties from our growing portfolio
      </p>

      <Swiper
        slidesPerView={3}
        spaceBetween={32}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        modules={[Autoplay, Pagination]}
        className="pb-12"
        breakpoints={{
          320: {
            slidesPerView: 1,
            spaceBetween: 16
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 24
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 32
          }
        }}
      >
        {filteredProperties.map((property) => (
          <SwiperSlide key={property.id}>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              <PropertyCard property={property} />
            </motion.div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}